/// <reference path="../../Common/Helpers/GridEditorBase.ts" />


namespace RioERP.Orders {
    
    @Serenity.Decorators.registerEditor()
    export class OrderProductsEditor extends Common.GridEditorBase<OrderProductsRow> {
        protected getColumnsKey() { return 'Orders.OrderProducts'; }
        protected getDialogType() { return OrderProductsEditDialog; }
     
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        public stateid: number;

        constructor(container: JQuery) {
            super(container);
        }

        protected getAddButtonCaption() {
            return "Add";   
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>) {
            super.initEntityDialog(itemType, dialog);
            //debugger;
            // passing discount from grid editor to detail dialog
            (dialog as OrderProductsEditDialog).stateIds = this.stateid;
        }
        protected getQuickFilters() {

            var filters = super.getQuickFilters();
            filters.splice(Q.indexOf(filters, x => x.field == "OrderSourceType"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderIsEmailSent"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderFranchiseeId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderShippingStatus"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderId"), 1);


            return filters;

        }

        validateEntity(row, id) {
            row.ProductId = Q.toId(row.ProductId);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ProductId === row.ProductId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Product is already added!');
                return false;
            }           
            return true;
        }
    }
}